// Shared helpers for the Inventory Specials Command Center surfaces (Phase D).
export const fmtIncentive = (inc, t, lang = 'en') => {
    if (!inc) return '—';
    if (inc.kind === 'cash' && inc.amount != null) return t('rebateAlert.offAmount', { amount: inc.amount });
    const lbl = inc.label || {};
    return lbl[lang] || lbl.en || t('rebateAlert.perk');
};

export const fmtDate = (iso) => {
    if (!iso) return '';
    try { return new Date(iso).toLocaleDateString(); } catch { return iso; }
};

export const AUTO_EVENT_LABELS = {
    'vehicle.tap': 'Tap Visit', 'vehicle.contact_sales': 'Question', 'vehicle.sms_out': 'SMS → customer',
    'vehicle.sms_in': 'SMS ← customer', 'vehicle.test_drive_requested': 'Test drive requested',
    'vehicle.test_drive_booked': 'Test drive booked', 'vehicle.test_drive_declined': 'Test drive declined',
    'vehicle.saved': 'Saved', 'vehicle.special_offer_click': 'Offer claimed',
    // F&I desk (Phase B) + the CONFIDENTIAL insurance signal (Phase C). The
    // insurance row is a SIGNAL only — the thread itself is never reachable here.
    'vehicle.fi_calculator_opened': 'Payment calculator opened',
    'vehicle.fi_prequal_submitted': 'Financing application',
    'vehicle.fi_warranty_interest': 'Warranty interest',
    'vehicle.insurance_quote_requested': 'Insurance quote requested (confidential)',
    'vehicle.trade_in_submitted': 'Trade-in submitted',
    'vehicle.form_abandoned': 'Started a form, didn’t finish',
    'vehicle.test_drive_gift_issued': 'Test drive gift sent',
    'vehicle.review_requested': 'Review request sent',
    'vehicle.share_created': 'Vehicle Shared', 'vehicle.share_opened': 'Shared Link Opened',
    'vehicle.share_viewed': 'Shared Vehicle Viewed',
};
